/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ServiceLevelWithFeesResource } from './';
import {
    ServiceLevelWithFeesResourceFromJSON,
    ServiceLevelWithFeesResourceFromJSONTyped,
    ServiceLevelWithFeesResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AllServiceLevelWithFeesResource
 */
export interface AllServiceLevelWithFeesResource {
    /**
     * 
     * @type {Array<ServiceLevelWithFeesResource>}
     * @memberof AllServiceLevelWithFeesResource
     */
    serviceLevels?: Array<ServiceLevelWithFeesResource>;
}

/**
 * Check if a given object implements the AllServiceLevelWithFeesResource interface.
 */
export function instanceOfAllServiceLevelWithFeesResource(value: object): value is AllServiceLevelWithFeesResource {
    return true;
}

export function AllServiceLevelWithFeesResourceFromJSON(json: any): AllServiceLevelWithFeesResource {
    return AllServiceLevelWithFeesResourceFromJSONTyped(json, false);
}

export function AllServiceLevelWithFeesResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllServiceLevelWithFeesResource {
    if (json == null) {
        return json;
    }
    return {
        
        'serviceLevels': json['serviceLevels'] == null ? undefined : ((json['serviceLevels'] as Array<any>).map(ServiceLevelWithFeesResourceFromJSON)),
    };
}

export function AllServiceLevelWithFeesResourceToJSON(value?: AllServiceLevelWithFeesResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'serviceLevels': value['serviceLevels'] == null ? undefined : ((value['serviceLevels'] as Array<any>).map((v) => ServiceLevelWithFeesResourceToJSON(v))),
    };
}

